import ModuleHeader from "~/components/design-system/pages/internal/ModuleHeader"
import ModuleInspector from "~/components/design-system/pages/internal/ModuleInspector"
import InspectorResizeHandle from "~/components/design-system/pages/internal/InspectorResizeHandle"
import ModuleTabs from "~/components/design-system/pages/internal/ModuleTabs"
import ModuleViewConfiguration from "~/components/design-system/pages/internal/ModuleViewConfiguration"
import { InspectorDrilldownProvider } from "~/components/design-system/pages/internal/InspectorDrilldownContext"
import { InspectorProvider } from "~/components/design-system/pages/internal/InspectorContext"
import { InspectorSelectionProvider } from "~/components/design-system/pages/internal/InspectorSelectionContext"
import { InspectorHighlightProvider } from "~/components/design-system/pages/internal/inspectorHighlight"
import { type ModuleProps } from "~/components/design-system/pages/types"
import { TableRegistryProvider } from "~/components/planning/TableRegistryContext"

/**
 * The page shell — every screen wraps in exactly one Module.
 * Canonical intent: {@link ../intents.ts MODULE_INTENT}.
 * Approved surface: design-system/APPROVED.md · Patterns: design-system/pages/README.md.
 */
const Module = ({ breadcrumb, actions, tabs, children }: ModuleProps) => {
  return (
    <TableRegistryProvider>
      {/* Drilldown outside the inspector provider: the inspector reads the open stack's width
          floor. */}
      <InspectorDrilldownProvider>
        <InspectorProvider hasTabs={!!tabs}>
          <InspectorSelectionProvider>
            <InspectorHighlightProvider>
              <div id="content-card" className="relative flex h-full w-full flex-col">
                <ModuleHeader breadcrumb={breadcrumb} actions={actions} />
                {tabs && <ModuleTabs items={tabs.items} path={tabs.path} actions={tabs.actions} />}
                <ModuleViewConfiguration />
                <div className="flex flex-1 min-h-0 flex-row overflow-x-clip">
                  <div className="flex-1 min-w-0 min-h-0 flex flex-col">{children}</div>
                  <InspectorResizeHandle />
                  <ModuleInspector />
                </div>
              </div>
            </InspectorHighlightProvider>
          </InspectorSelectionProvider>
        </InspectorProvider>
      </InspectorDrilldownProvider>
    </TableRegistryProvider>
  )
}

export default Module
